const keysModule = {
  namespaced: true,

  state: {
    googleMapsApiKey: null,
    deployEnvironmentKey: null,
    chromaticUrl: null,
  },

  mutations: {
    setGoogleMapsApiKey(state, googleMapsApiKey) {
      state.googleMapsApiKey = googleMapsApiKey;
    },
    setDeployEnvironmentKey(state, deployEnvironmentKey) {
      state.deployEnvironmentKey = deployEnvironmentKey;
    },
    setChromaticUrl(state, chromaticUrl) {
      state.chromaticUrl = chromaticUrl;
    },
  },

  actions: {
    setGoogleMapsApiKey({ commit }, googleMapsApiKey) {
      commit('setGoogleMapsApiKey', googleMapsApiKey);
    },
    setDeployEnvironmentKey({ commit }, deployEnvironmentKey) {
      commit('setDeployEnvironmentKey', deployEnvironmentKey);
    },
    setChromaticUrl({ commit }, chromaticUrl) {
      commit('setChromaticUrl', chromaticUrl);
    },
  },

  getters: {
    getGoogleMapsApiKey(state) {
      return state.googleMapsApiKey;
    },
    getDeployEnvironmentKey(state) {
      return state.deployEnvironmentKey;
    },
    getChromaticUrl(state) {
      return state.chromaticUrl;
    },
  },
};

export default keysModule;
